import { render, staticRenderFns } from "./StudyResultDetail.vue?vue&type=template&id=762f6296&lang=pug"
import script from "./StudyResultDetail.vue?vue&type=script&lang=ts"
export * from "./StudyResultDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports